import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import {
  BiSolidSkipNextCircle,
  BiSolidSkipPreviousCircle,
} from "react-icons/bi";
import { getCurrentDate } from "../Utilitie";
import AnimatedDisplay from "../CHARTS/AnimatedDisplay";
const months = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];
const getLast30Days = () => {
  const days = [];
  const today = new Date();

  for (let i = 0; i < 30; i++) {
    const date = new Date(today);
    date.setDate(today.getDate() - i);
    days.push(date.toISOString().split("T")[0]);
  }

  return days;
};

const InsertionDetails = ({ pageData }) => {
  const scrollRef = useRef(null);

  const [tableData, setTableData] = useState([]);
  const urlPrefix = process.env.REACT_APP_URL_PREFIX;
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [selectedDate, setSelectedDate] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const { data: response } = await axios.get(
          `${urlPrefix}getAdminDateWise?startDate=${getCurrentDate()}`,
        );
        if (response.status === "ok" && Array.isArray(response.data)) {
          setTableData(response.data);
        }
      } catch (err) {
        console.error("Fetch error:", err);
        setError(true);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const matchingTable = tableData.find(
    (table) => table.table_name === pageData.TableName,
  );

  const last30Days = getLast30Days();
  const scrollLeft = () => {
    scrollRef.current.scrollBy({ left: -470, behavior: "smooth" });
  };

  const scrollRight = () => {
    scrollRef.current.scrollBy({ left: 470, behavior: "smooth" });
  };
  if (loading) {
    return (
      <div className="d-flex align-items-center justify-content-center gap-2 py-3 text-secondary text-center">
        <span
          className="spinner-border spinner-border-sm"
          role="status"
          aria-hidden="true"
        />
        <span className="small">Loading insertion history...</span>
      </div>
    );
  }
  return (
    <div className="d-flex align-items-center  ">
      {matchingTable ? (
        <React.Fragment>
          {/* Previous Button */}
          <button
            type="button"
            onClick={scrollLeft}
            className="btn btn-light border shadow-sm rounded-circle d-flex
               align-items-center justify-content-center flex-shrink-0 p-0
               me-2"
            style={{
              width: "38px",
              height: "38px",
              color: "#063b87",
            }}
            title="Previous dates"
          >
            <BiSolidSkipPreviousCircle size={24} />
          </button>

          {/* Date Navigation */}
          <div
            ref={scrollRef}
            className="d-flex overflow-hidden flex-nowrap align-items-center py-2 px-1"
            style={{
              maxWidth: "550px",
              minWidth: 0,
              height: "82px",
              scrollBehavior: "smooth",
            }}
          >
            {last30Days.map((date, idx) => {
              const entry = matchingTable.records.find(
                (d) => d.record_date.slice(0, 10) === date,
              );

              const hasData = !!entry;
              const isSelected = selectedDate === date;

              const day = date.slice(8, 10);
              const month = months[Number(date.slice(5, 7)) - 1];

              return (
                <div
                  key={date}
                  // onClick={() => setSelectedDate(date)}
                  role="button"
                  tabIndex={0}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      e.preventDefault();
                      setSelectedDate(date);
                    }
                  }}
                  className="position-relative d-flex flex-column
                     align-items-center justify-content-center
                     flex-shrink-0 rounded-3 mx-1"
                  style={{
                    minWidth: "70px",
                    height: "62px",
                    // cursor: "pointer",
                    border: isSelected
                      ? "2px solid #063b87"
                      : `1px solid ${hasData ? "#b6e5c3" : "#f1c5c5"}`,
                    background: isSelected
                      ? "#063b87"
                      : hasData
                        ? "#effaf2"
                        : "#fff3f3",
                    color: isSelected
                      ? "#ffffff"
                      : hasData
                        ? "#16763a"
                        : "#c03939",
                    boxShadow: isSelected
                      ? "0 3px 10px rgba(6,59,135,0.22)"
                      : "0 2px 5px rgba(0,0,0,0.05)",
                    transition: "all 0.2s ease",
                  }}
                >
                  {/* Record Count */}
                  {hasData && (
                    <span
                      className="position-absolute top-0 end-0
                         translate-middle-y badge rounded-pill"
                      style={{
                        fontSize: "10px",
                        background: isSelected ? "#ffffff" : "#198754",
                        color: isSelected ? "#063b87" : "#ffffff",
                        border: isSelected ? "1px solid #063b87" : "none",
                        right: "-4px",
                      }}
                    >
                      {entry.count}
                    </span>
                  )}

                  {/* Day */}
                  <div className="fw-bold lh-1" style={{ fontSize: "21px" }}>
                    <AnimatedDisplay value={day} />
                  </div>

                  {/* Month */}
                  <div
                    className="small fw-semibold mt-1"
                    style={{
                      fontSize: "11px",
                      letterSpacing: "0.5px",
                      opacity: 0.9,
                    }}
                  >
                    <AnimatedDisplay value={month} />
                  </div>

                  {/* Status Indicator */}
                  <span
                    className="position-absolute bottom-0 start-50
                       translate-middle-x rounded-pill"
                    style={{
                      width: "18px",
                      height: "3px",
                      marginBottom: "3px",
                      background: isSelected
                        ? "#ffffff"
                        : hasData
                          ? "#198754"
                          : "#dc3545",
                    }}
                  />
                </div>
              );
            })}
          </div>

          {/* Next Button */}
          <button
            type="button"
            onClick={scrollRight}
            className="btn btn-light border shadow-sm rounded-circle d-flex
               align-items-center justify-content-center flex-shrink-0 p-0
               ms-2"
            style={{
              width: "38px",
              height: "38px",
              color: "#063b87",
            }}
            title="Next dates"
          >
            <BiSolidSkipNextCircle size={24} />
          </button>
        </React.Fragment>
      ) : (
        <div className="row text-center" style={{ width: "100%" }}>
          <p style={{ color: "red", fontSize: "15px" }} className="text-center">
            {pageData.pageName === "Manage PDFs"
              ? "No Date wise insertion"
              : `No Data Found for ${pageData.TableName}`}
          </p>
        </div>
      )}
    </div>
  );
};

export default InsertionDetails;
